import { render, staticRenderFns } from "./PhoneCheckPopup.vue?vue&type=template&id=2dfc21b8&scoped=true&"
import script from "./PhoneCheckPopup.vue?vue&type=script&lang=js&"
export * from "./PhoneCheckPopup.vue?vue&type=script&lang=js&"
import style0 from "./PhoneCheckPopup.vue?vue&type=style&index=0&id=2dfc21b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfc21b8",
  null
  
)

export default component.exports